"use strict";

angular.module("licensure.services").factory("FireDrill", [
    "$http",
    "$q",
    function ($http, $q) {
        return {
            getPublicSchoolSystems: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/Core/PublicFireDrillSchoolSystems", {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getPublicSchools: function (params) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/Core/PublicFireDrillSchools", {
                        params: params
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getPublicFireDrills: function (params) {
                var d = $q.defer();
                $http
                    .get(apiLocation + "/api/Core/PublicFireDrills", {
                        params: params
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getPublicYears: function (params) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/Core/PublicFireDrillYears", {
                        params: params
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },
        };
    }
]);
